
  <div @fadeInAnimation class="food-group-type">
    <ul class="ingredient-list ml-xs mt-md" *ngIf="blockPeriod.ingredients.length> 0" @fadeInAnimation [class.blocked]="showSelectIngredients">
      <div *ngFor="let ingredient of blockPeriod.ingredients; index as i" class="ingredient-item">
        <li @fadeInAnimation class="text-info d-flex" (click)="onSetIngredientToEdit(ingredient)">
          <span [class.tw-text-orange-500]="ingredient.isDislike && !ingredient.isAllergic" [class.tw-text-red-500]="ingredient.isAllergic">
            {{ ingredient.ingredientName }}. {{ ingredient.units.toFixed(2) }} {{ ingredient.units > 1 ? (ingredient.measure.namePlural_es ||
            ingredient.measure.namePlural) : (ingredient.measure.name_es || ingredient.measure.name) }}.</span>
          <img loading="lazy" class="icon-edit-ingredient" src="./../../../assets/images/icons/icons8-lapiz-100.png" alt="">
        </li>
        <div @fadeInAnimation *ngIf="ingredient.ingredientId === this.blockPeriod.ingredientToEdit?.ingredientId && !showSelectIngredients"
          class="tw-w-full d-flex mb-md" style="gap: 1rem">
          <button
            (click)="onCheckPropertiesBlockTypeIndividual()"
            nz-button nzType="default" class="btn-default">
            <i nz-icon nzType="edit" nzTheme="outline" *ngIf="!loadingIngredient"></i>
            <i nz-icon nzType="loading" nzTheme="outline" *ngIf="loadingIngredient"></i>
            Editar
          </button>
          <button
            (click)="onRemoveIngredient(ingredient)"
            nz-button nzType="default" class="btn-default">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
            Eliminar
          </button>
        </div>
      </div>
    </ul>

    <!-- TODO: Temporal, revisar funcionamiento -->
    <ng-container *ngIf="blockPeriod.ingredients.length === 0"> 
      <div class="add-menu d-flex align-items-center mb-sm" *ngIf="!showSelectIngredients" (click)="this.blockPeriod.ingredientToEdit= null; onShowFormIngredient()">
        <i nz-icon nzType="plus" nzTheme="outline" class="mr-xxs"></i>
        <p class="text-info">Añadir un ingrediente</p>
      </div>
    </ng-container>


    <div *ngIf="showSelectIngredients">
      <app-form-ingredient
        [ingredient]="this.blockPeriod.ingredientToEdit"
        [hasCategoryFilter]="true"
        [hasIngredientName]="true"
        [hasNutritionalProperties]="true"
        [hasMeasurementUnit]="true"
        [hasUnits]="true"
        [hasActionButtons]="true"
        [showForm]="true"
        [mealPlanType]="mealPlanType"
        (save)="onEmitSaveIngredient($event)"
        (cancel)="onCancelEditIngredient()"></app-form-ingredient>
    </div>

    <div class="line-divider mt-xs mb-md" *ngIf="blockPeriod.ingredients.length> 0" @fadeInAnimation></div>
    <div class="macronutrients d-flex justify-content-between mb-md" *ngIf="blockPeriod.ingredients.length> 0" @fadeInAnimation>
      <div class="macronutrient">
        <p class="text-info-bold-xs mb-xxs opacity-70">Calorías</p>
        <p class="text-info text-bold">{{ blockPeriod.nutritionalProperties?.energy_kcal.toFixed(2) || 0 }} kcal</p>
      </div>
      <div class="macronutrient">
        <p class="text-info-bold-xs mb-xxs opacity-70">Grasas</p>
        <p class="text-info text-bold">{{ blockPeriod.nutritionalProperties?.totalFat_g.toFixed(2) || 0 }} g</p>
      </div>
      <div class="macronutrient">
        <p class="text-info-bold-xs mb-xxs opacity-70">Carbohidratos</p>
        <p class="text-info text-bold">{{ blockPeriod.nutritionalProperties?.carbohydrate_g.toFixed(2) || 0 }} g</p>
      </div>
      <div class="macronutrient">
        <p class="text-info-bold-xs mb-xxs opacity-70">Proteínas</p>
        <p class="text-info text-bold">{{ blockPeriod.nutritionalProperties?.protein_g.toFixed(2) || 0 }} g</p>
      </div>
      <div class="macronutrient">
        <p class="text-info-bold-xs mb-xxs opacity-70">Fibra</p>
        <p class="text-info text-bold">{{ blockPeriod.nutritionalProperties?.dietaryFiber_g.toFixed(2) || 0 }} g</p>
      </div>
    </div>
  </div>
